import React from 'react';
import PropTypes from 'prop-types';
import {Form, Accordion, Card} from 'react-bootstrap';
import PortionPropertiesTable from './PortionPropertiesTable.js';
import { PortionPropertiesTableId } from '../utils/generic_utils.js';
const CustomizationChoices = ({setCustomizationChoices, customizationChoices, formErrors, setFormErrors}) => {
  const setCustomizationChoiceChoices = (parentId, choices) => {
    setCustomizationChoices(customizationChoices.map(cc => {
      return cc.id === parentId ? {...cc, choices} : {...cc};
    }));
  };
  return (
    <Form.Group>
      <Card>
        <Accordion>
          <Card.Header>
            <Card.Title>Customization choices</Card.Title>
          </Card.Header>
          <Card.Body>
            <PortionPropertiesTable
              identifierKey={'id'}
              items={customizationChoices}
              setItems={setCustomizationChoices}
              setFormErrors={setFormErrors}
              formErrors={formErrors}
              hasCollapse={true}
              tableId={PortionPropertiesTableId.CUSTOMIZATION_CHOICES}
            />
          </Card.Body>
          {customizationChoices.map(customizationChoice => {

            return (
              <React.Fragment key={`${customizationChoice.id}_children`}>
                <Accordion.Collapse eventKey={customizationChoice.id}>
                  <Card.Body>
                    <Card.Title>{customizationChoice.id}</Card.Title>
                    <PortionPropertiesTable
                      identifierKey={'id'}
                      items={customizationChoice.choices}
                      setItems={(choices) => setCustomizationChoiceChoices(customizationChoice.id, choices)}
                      setFormErrors={setFormErrors}
                      formErrors={formErrors}
                      size="sm"
                      tableId={PortionPropertiesTableId.CUSTOMIZATION_CHOICE_CHOICES}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </React.Fragment>
            );
          })}
        </Accordion>
      </Card>
    </Form.Group>
  );
};
CustomizationChoices.propTypes = {
  setCustomizationChoices: PropTypes.func,
  customizationChoices: PropTypes.array,
  formErrors: PropTypes.object,
  setFormErrors: PropTypes.func
};
CustomizationChoices.defaultProps = {
  customizationChoices: []
};
export default CustomizationChoices;